import { darkColors, lightColors } from "./colors";

import { flattenComponentColorTokens } from "./utils";

// Reference: https://www.notion.so/puzzlefin/RFC-Semantic-Design-Tokens-160e2568623680feadbbecc8038e5f96?source=copy_link#209e2568623680d09856d0ea2bd7b9c5

// Control Tokens
// Controls are:
// - text inputs, textareas, date inputs, checkboxes, radio buttons
// - select boxes, dropdown menus, search box, date pickers

// - Outlines
//     - control-outline-hover
//     - control-outline-focus
//     - control-outline-idle
//     - control-outline-active
//     - control-outline-disabled
//     - control-outline-error
// - Surfaces (text input, date input, textarea checkbox, radio backgrounds)
//     - control-surface-hover
//     - control-surface-focus
//     - control-surface-idle
//     - control-surface-active
//     - control-surface-disabled
//     - control-surface-error
// - Surfaces Interactive (select, dropdown menus, searchbox)
//     - control-surfaceInteractive-hover
//     - control-surfaceInteractive-focus
//     - control-surfaceInteractive-idle
//     - control-surfaceInteractive-active
//     - control-surfaceInteractive-disabled
//     - control-surfaceInteractive-error

// Usage
// In Stitches:
// borderColor: "$componentColors$control-outline-idle",
//
// In Vanilla Extract:
// borderColor: vars.componentColors["control-outline-idle"],

// TODO: Populate surface and surfaceInteractive for both themes

// Dark Theme
const outline = {
  hover: darkColors["outline-neutral-highlight"],
  focus: darkColors["outline-special-base"],
  idle: darkColors["outline-neutral-subdue"],
  active: darkColors["outline-special-base"],
  disabled: darkColors["outline-neutral-subdue"],
  error: darkColors["outline-error-base"],
};

const surface = {
  hover: darkColors["text-neutral-base"],
  focus: darkColors["text-neutral-base"],
  idle: darkColors["text-neutral-base"],
  active: darkColors["text-neutral-base"],
  disabled: darkColors["text-neutral-base"],
  error: darkColors["text-neutral-base"],
};

const surfaceInteractive = {
  hover: darkColors["text-neutral-base"],
  focus: darkColors["text-neutral-base"],
  idle: darkColors["text-neutral-base"],
  active: darkColors["text-neutral-base"],
  disabled: darkColors["text-neutral-base"],
  error: darkColors["text-neutral-base"],
};

const componentColorTokensDark = {
  control: {
    outline,
    surface,
    surfaceInteractive,
  },
};
export const flatComponentColorTokensDark = flattenComponentColorTokens(componentColorTokensDark);
export const darkComponentColors = {
  ...flatComponentColorTokensDark,
};

// Light Theme
const lightOutline = {
  hover: lightColors["outline-neutral-highlight"],
  focus: lightColors["outline-special-base"],
  idle: lightColors["outline-neutral-subdue"],
  active: lightColors["outline-special-base"],
  disabled: lightColors["outline-neutral-subdue"],
  error: lightColors["outline-error-base"],
};

const lightSurface = {
  hover: lightColors["text-neutral-base"],
  focus: lightColors["text-neutral-base"],
  idle: lightColors["text-neutral-base"],
  active: lightColors["text-neutral-base"],
  disabled: lightColors["text-neutral-base"],
  error: lightColors["text-neutral-base"],
};

const lightSurfaceInteractive = {
  hover: lightColors["text-neutral-base"],
  focus: lightColors["text-neutral-base"],
  idle: lightColors["text-neutral-base"],
  active: lightColors["text-neutral-base"],
  disabled: lightColors["text-neutral-base"],
  error: lightColors["text-neutral-base"],
};

const componentColorTokensLight = {
  control: {
    outline: lightOutline,
    surface: lightSurface,
    surfaceInteractive: lightSurfaceInteractive,
  },
};

export const flatComponentColorTokensLight = flattenComponentColorTokens(componentColorTokensLight);
export const lightComponentColors = {
  ...flatComponentColorTokensLight,
};
